import { Sparkles, Fingerprint, Clock, BatteryCharging, HeartHandshake } from "lucide-react";

export const modules = [
  {
    title: "Entdecke, wer Du wirklich bist.",
    short:
      "Du erhältst Klarheit über Deine Stärken, Deine Werte, Deine Persönlichkeit, Deinen bisherigen Weg und Deine verborgenen Schätze.",
    sub: "Wer bin ich?",
    intro:
      "Solange Du keine Klarheit über Deine Stärken, Werte und Bedürfnisse hast, orientierst Du Dich an äußeren Maßstäben – statt an Dir selbst.",
    points: [
      ["Deine Einzigartigkeit", "Du tauchst ein in die Welt Deiner einzigartigen Stärken und verborgenen Talente."],
      ["Deine verborgenen Schätze", "Gemeinsam graben wir Eigenschaften und Fähigkeiten aus, die wahrscheinlich jahrelang im Verborgenen lagen."],
      ["Werte-Check", "Du findest heraus, welche Werte Dein Leben leiten."],
      ["Selbstwertboost", "Du verabschiedest Dich von alten Glaubenssätzen und fängst an, selbstbewusst zu Dir und Deinen Stärken zu stehen."],
      ["Klarheit auf einen Blick", "Du erstellst ein Selbstprofil als Orientierung für Deinen weiteren Weg und Grundlage für all Deine Bewerbungen."],
    ],
    t: {
      name: "Luisa",
      img: "luisa",
      lead: "Ich habe einen neuen Job angefangen, der mich glücklich macht und genau die Werte widerspiegelt, die für mich wichtig sind.",
      ps: [
        "Ich war nicht mehr glücklich in meinem aktuellen Beruf. Ich brauchte eine Veränderung, wusste aber nicht, was ich wirklich will und was zu mir passt.",
        "Ich bin jetzt nach dem Coaching viel selbstbewusster, leidenschaftlicher und habe viel mehr Energie. Ich weiß, was ich will und es tut mir so gut, ein Ziel zu haben.",
        "Ich kann das Programm allen weiterempfehlen, die noch unsicher sind, die etwas erreichen möchten, aber noch nicht wissen, wie. Es ist super, um seinen Weg wiederzufinden.",
      ],
    },
  },
  {
    title: "Lass Deine Träume größer werden als Deine Ängste.",
    short:
      "Du löst Dich von allen Erwartungen und „das geht doch nicht“-Gedanken und begibst Dich auf ein ganz neues Spielfeld. In einem geschützten Rahmen findest Du heraus, was Du wirklich, wirklich willst.",
    sub: "Wer könnte ich sein?",
    intro:
      "Veränderung geht immer mit Unsicherheit einher. Es geht nicht darum, dass Du keine Angst mehr hast – sondern darum, eine Vision zu entwickeln, für die es sich lohnt, trotz Angst loszugehen.",
    points: [
      ["Raus aus dem „Das geht doch nicht!“-Muster", "Du überwindest innere Blockaden und gesellschaftliche Erwartungen."],
      ["Neue Facetten von Dir entdecken", "Gemeinsam finden wir Deine verborgenen Leidenschaften und Wünsche."],
      ["Die Traumformel", "Du erlaubst Dir, ohne Einschränkungen zu träumen."],
      ["Dein idealer Tag", "Du visualisierst Deinen perfekten Tag."],
    ],
    t: {
      name: "Sophia",
      img: "sophia",
      lead: "Ich habe meinen Traumjob gefunden!",
      ps: [
        "Vor dem Coaching hätte ich gar nicht gewusst, dass er in dieser Form existiert.",
        "Ich war vor dem Coaching völlig energielos und wusste: Das geht so nicht weiter!",
        "Ich bin jetzt wieder voller Energie. Vor dem Coaching hätte ich meinen Traumjob gar nicht erkannt. Ich hätte nicht den Mut gehabt und nicht verstanden, dass all die Aufgaben, die in der Stellenanzeige stehen, Dinge sind, die ich gerne mache.",
        "Jede, die nicht weiß, wo sie beruflich hin möchte, ist hier gut aufgehoben und kann beruflich und privat daran nur wachsen.",
      ],
    },
  },
  {
    title: "Mach Deine Vision zu Deiner Realität.",
    short:
      "Du integrierst die Erkenntnisse der ersten beiden Schritte, definierst Deine konkreten Ziele und erarbeitest einen realistischen Umsetzungsplan.",
    sub: "Wie werde ich die, die ich sein will?",
    intro: "Eine Vision ohne Plan bleibt nur ein Traum. Jetzt ist der Moment, ins Handeln zu kommen.",
    points: [
      ["Dein neuer Nordstern", "Ein inspirierendes Zielbild, das Dich täglich leitet."],
      ["Deine Zielidentität", "Du beginnst schon jetzt, in Deine neue Rolle hineinzuwachsen."],
      ["Deine klare Roadmap", "Ein realistischer Plan mit kleinen, machbaren Schritten."],
      ["Jetzt loslegen", "Deine ersten Schritte in die Tat umsetzen."],
      ["Hindernisse transformieren", "Hinderliche Glaubenssätze in kraftvolle Überzeugungen wandeln."],
    ],
    t: {
      name: "Barbara",
      img: "barbara",
      lead: "Ich bin total glücklich, dass ich jetzt diese Klarheit und Sicherheit habe!",
      ps: [
        "Vorher habe ich mich gefühlt 3 Jahre im Kreis gedreht und war von dem ewigen Herumprobieren genervt. Bücher durcharbeiten und selbst 1:1 Coachings haben mir nicht richtig weitergeholfen.",
        "Ich glaube, ohne das Coaching wäre ich immer noch jemand mit vielen Hobbys (statt profitabler Selbstständigkeit) und würde plan- und strukturlos durch die Weltgeschichte taumeln. Stattdessen weiß ich jetzt genau, wer ich bin und wo ich hin will und das ist super!",
      ],
    },
  },
];

export const boni = [
  {
    title: "Rewrite the Rules",
    wert: "479 €",
    teaser: "Mach Dir Deine alten, limitierenden Spielregeln bewusst und verabschiede Dich von ihnen – für Dein ganz eigenes, neues Spiel.",
    intro: [
      "Die Art, wie Du denkst, bestimmt die Art, wie Du lebst – und ob Du überhaupt losgehst für das, was Du wirklich willst.",
      "In diesem kompakten Audiokurs schärfst Du Deine Wahrnehmung, hinterfragst alte Denkmuster und stärkst Dein Vertrauen in Dich selbst.",
    ],
    listTitle: "Was Du daraus mitnimmst:",
    list: [
      "Ein neues Bewusstsein für die Wirkung Deiner Gedanken",
      "Erste Erfolgserlebnisse durch bewusstes Dranbleiben",
      "Eine stärkende Haltung, die Dich durch den gesamten Prozess trägt",
    ],
  },
  {
    title: "Inner Shift",
    wert: "149 €",
    teaser: "Mentaltrainings, mit dem Du Dein Selbstbewusstsein stärkst.",
    intro: [
      "Veränderung beginnt im Kopf – und sie braucht Deine innere Ausrichtung.",
      "Wenn Du bisher noch stark an Dir und Deinen Fähigkeiten zweifelst, das Hochstaplersyndrom regelmäßig reinkickt und Du Dich innerlich klein hältst – dann sind diese Mentaltrainings genau für Dich gemacht.",
    ],
    listTitle: "Was es für Dich bewirkt:",
    list: [
      "Stärkt Dein Selbstvertrauen von innen heraus",
      "Etabliere neue, förderliche Glaubenssätze",
      "Richte Dein Unbewusstes auf Erfolg aus",
      "Spüre mit jedem Hören mehr: Das ist für mich möglich!",
    ],
  },
  {
    title: "Emotional Reset",
    wert: "369 €",
    teaser: "Meditationsduo, mit dem Du innerhalb kurzer Zeit wieder in Dein inneres Gleichgewicht findest.",
    intro: [
      "Der hektische (Arbeits-)Alltag kann schnell Gefühle von Überforderung oder Stress auslösen – da fällt es gar nicht so leicht, einen klaren Kopf zu behalten.",
      "Dieses Meditationsduo hilft Dir, in herausfordernden Momenten zurück in Deine Mitte zu finden – und schwierige Gefühle nicht (mehr) zu vermeiden, sondern anzunehmen.",
    ],
    listTitle: "Diese Meditationen helfen Dir:",
    list: [
      "Stress & Überforderung in wenigen Minuten zu regulieren",
      "Schwierige Gefühle wie Wut, Angst oder Traurigkeit anzunehmen",
      "Innere Ruhe & emotionale Stärke aufzubauen",
      "Wieder klar zu denken – auch mitten im Gefühlschaos",
      "In Verbindung mit Dir zu bleiben, statt Dich zu verlieren",
    ],
  },
  {
    title: "Bewerbungs\u00ADbooster inkl. Bewerbungs\u00ADunterlagen-Check",
    wert: "599 €",
    teaser: "Masterclass & 1:1-Check für Bewerbungen mit Wow-Faktor.",
    intro: [
      "Deine letzte Bewerbung ist ewig her und Du weißt gar nicht, worauf Du überhaupt achten musst – vor allem, wenn Du Dich vielleicht als Quereinsteigerin bewirbst?",
      "Dann ist dieser Bonus Dein Gamechanger.",
    ],
    listTitle: "Du bekommst…",
    list: [
      "Eine aufgezeichnete Masterclass mit Insiderwissen aus 10+ Jahren Personalauswahl",
      "Strategien speziell für Quereinsteigerinnen",
      "Klarheit über Dos & Don'ts im Bewerbungsprozess",
      "Selbstbewusste Sprache für Deine Einzigartigkeit",
      "Individuelles Feedback zu DEINEN Bewerbungsunterlagen, wenn Du Dich im Rahmen unserer Zusammenarbeit auf Stellen bewirbst",
    ],
    outro: "Damit Deine Bewerbung nicht nur gut, sondern unwiderstehlich wird.",
  },
  {
    title: "Luisa's Business Nähkästchen",
    wert: "379 €",
    teaser: "Masterclass & Q&As für Deinen erfolgreichen Start in die Selbstständigkeit.",
    intro: [
      "Wenn Du während des Coachings merkst, dass die Selbstständigkeit Dich reizt, dann ist dieser Bonus für Dich:",
      "Ich nehm Dich mit hinter die Kulissen, wie ich mein Business aufgebaut habe – ungefiltert und praxisnah.",
    ],
    listTitle: "Du bekommst…",
    list: [
      "Eine aufgezeichnete Masterclass mit ehrlichen Einblicken aus 5+ Jahren Selbstständigkeit",
      "Die wichtigsten To-dos für Deinen Start",
      "Tipps zu Netzwerken, Sichtbarkeit und ersten Kund:innen",
      "Impulse zu Pricing, Money Mindset & Deiner Identität als Unternehmerin",
    ],
    outro: "Damit Du Dich nicht von Bürokratie abhalten oder von Shiny Objects ablenken lässt, sondern direkt losstarten kannst.",
  },
];

export const vorstellen = [
  { icon: Sparkles, t: "… Du hast einen Job, der sich vor allem von innen großartig anfühlt – ganz egal, wie andere darüber denken." },
  { icon: Fingerprint, t: "… Deine Arbeit entspricht Dir und Deinem Wesen – und hilft Dir, noch mehr ganz Du zu werden." },
  { icon: Clock, t: "… Du gestaltest Deinen Arbeitstag so, wie er zu Dir passt – Zeiten, Ort, Tempo – und kreierst dabei gleichzeitig das beste Ergebnis für alle." },
  { icon: BatteryCharging, t: "… Deine Energietanks werden während der Arbeit aufgeladen, statt leergesaugt." },
  { icon: HeartHandshake, t: "… Du wirkst Seite an Seite mit anderen statt gegeneinander – egal ob Du gerade Mitarbeiterin, Führungskraft oder Kundin bist." },
];

export const touchpoints = [
  ["Hot Seat Coaching Call mit Luisa", "Stelle Luisa Deine konkreten Fragen und profitiere von den Coachinggesprächen der anderen Teilnehmerinnen."],
  ["Telegram Tag mit Luisa", "Du schilderst Luisa Deine Fragen - und bekommst eine persönliche Sprachnachricht als Antwort."],
  ["Change the Game Call mit Luisa", "Löse Dich bewusst von alten limitierenden Spielregeln von Arbeit und kreiere Deine eigenen."],
  ["Q&A Call zu den Modulen", "Zur Vertiefung, mit Raum für Deine konkreten Fragen."],
  ["Community Call", "Gemeinsamer Austausch, Workshopping und Reflexion mit den anderen Teilnehmerinnen."],
];

export const investment = [
  { t: "12 Live Sessions (Hot Seat Coaching & Change the Game Call) mit Luisa", w: "3.600 €" },
  { t: "6 Telegram-Tage mit Luisa", w: "1.400 €" },
  { t: "12 Live Sessions (Q&A Call & Community Call)", w: "999 €" },
  { t: "Zugang zum Self-Study-Mitgliederbereich (6 Monate)", w: "1.800 €" },
  { t: "Direkter Draht zu Luisa & Team zwischen den Calls", w: "1.200 €" },
  { t: "Exklusive Community mit den anderen Teilnehmerinnen während der 6-monatigen Laufzeit", w: "unbezahlbar" },
];
